var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { resetAppStateAction } from "actions/application";
import { getLearningCategories } from "api/learningCategories";
const initialState = { isLoading: false, models: [], errors: [] };
export const getLearningCategoriesAction = createAsyncThunk("learningCategories/load", () => __awaiter(void 0, void 0, void 0, function* () { return yield getLearningCategories(); }));
const setIsLoading = (state) => {
    state.isLoading = true;
    state.errors = [];
};
const replaceLearningCategories = (state, action) => {
    state.isLoading = false;
    state.models = action.payload;
};
const replaceErrors = (state, error) => {
    state.isLoading = false;
    state.errors = [error];
};
const learningCategoriesSlice = createSlice({
    name: "learningCategories",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getLearningCategoriesAction.pending, setIsLoading)
            .addCase(getLearningCategoriesAction.fulfilled, replaceLearningCategories)
            .addCase(getLearningCategoriesAction.rejected, (state, action) => replaceErrors(state, action.error))
            .addCase(resetAppStateAction, () => initialState);
    },
});
export default learningCategoriesSlice;
